import { useContext, useState } from 'react';
import { Paper, Search } from '@safedns/skydns-ui-react-lib';

import UsersList from './UsersList';
import UsersAssignedFilter from './UsersAssignedFilter';
import Agents from './Agents';

import AuthContext from '../../contexts/authContext';

import styles from './Users.module.scss';

const Users = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [assignedFilter, setAssignedFilter] = useState('all');
  const { availableFeatures } = useContext(AuthContext);

  const { areAgentsAvailable, areCollectionsAvailable } = availableFeatures;

  const assignHandler = (e) => {
    setAssignedFilter(e.target.value);
  };

  const searchHandler = (e) => {
    setSearchQuery(e.target.value);
  };

  const clearField = () => {
    setSearchQuery('');
  };

  return (
    <>
      {areAgentsAvailable ? <Agents /> : null}
      {areCollectionsAvailable ? (
        <Paper title="AD Агенты">
          <form noValidate className={styles['users-control']}>
            <Search
              value={searchQuery}
              isClearButton
              isLensIconVisible
              placeholder="Найти пользователя"
              onClear={clearField}
              onChange={searchHandler}
              sx={{ maxWidth: 460 }}
            />
            <UsersAssignedFilter
              onChange={assignHandler}
              value={assignedFilter}
            />
          </form>
          <UsersList
            assignedFilter={assignedFilter}
            searchQuery={searchQuery}
          />
        </Paper>
      ) : null}
    </>
  );
};

export default Users;
